import { useCallback, useState } from 'react';

import {
  activarRapido,
  desactivarRapido,
  descartarOferta,
  leerRecuerdo,
  ofertaPausada,
  olvidar,
  type RecuerdoLocal,
  recordarEmail,
} from './rememberedUser';

/**
 * El usuario recordado en este navegador y las acciones para cambiarlo.
 * La lectura es síncrona (localStorage), así el formulario nace ya precargado.
 */
export function useRememberedUser() {
  const [recuerdo, setRecuerdo] = useState<RecuerdoLocal | null>(() => leerRecuerdo());

  const recordar = useCallback((email: string) => setRecuerdo(recordarEmail(email)), []);
  const activar = useCallback((email: string) => setRecuerdo(activarRapido(email)), []);
  const desactivar = useCallback(() => setRecuerdo(desactivarRapido()), []);
  const descartar = useCallback(() => setRecuerdo(descartarOferta()), []);
  const noSoyYo = useCallback(() => {
    olvidar();
    setRecuerdo(null);
  }, []);

  return {
    recuerdo,
    email: recuerdo?.email ?? '',
    /** Este navegador activó la entrada rápida para ese email. */
    rapido: recuerdo?.rapido === true,
    ofertaPausada: ofertaPausada(recuerdo),
    recordar,
    activar,
    desactivar,
    descartar,
    noSoyYo,
  };
}
